import MapFullscreeenEnum from '../../enumerators/single/map-fullscreen.enum'

export default class MapFullscreenAction {
    constructor() {
        MapFullscreenAction.toggleMap()
    }

    static toggleMap() {
        const fullScreenTrigger = MapFullscreeenEnum.MAP_FULLSCREEN_TRIGGER

        $(document).on('click', fullScreenTrigger, (e) => {
            e.preventDefault()
            $('body').toggleClass('map-fullscreen-active')
            $(document).trigger('iris-map/map/resize')
        })
    }
}
